import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { cardTypeTranslation } from '@/common/constants/cards.constant'
import { formatDateTime } from '@/common/utils/formatters'
import RequestNewCard from '@/features/cards/components/allCards/RequestNewCard'
import { ArrowBigRight, BriefcaseBusinessIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import Button from '../../../common/components/Button'
import AllCardsEquipment from '../components/allCards/AllCardsEquipment'
import AllCardsOwner from '../components/allCards/AllCardsOwner'
import { cardStatusTranslation } from '../constants/cardStatusTranslation.constant'
import { CardData } from '../types/card.type'
import CardNumberWithCopyButton from '@/common/components/CardNumberWithCopyButton'

export class PendingCardsTransformer {
  static tableTransformer() {
    return (cards: CardData[]) => {
      return cards.map((card) => {
        return {
          ...card,
          checkboxEnabled: card.status === 'validated',
          type: cardTypeTranslation[card.type],
          created_at: formatDateTime(new Date(card.created_at)),
          updated_at: card.updated_at ? formatDateTime(new Date(card.updated_at)) : '',
          card_number:  <CardNumberWithCopyButton card={card} />,
          status: card.status ? cardStatusTranslation[card.status] : '',
          company_branch: (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={card?.company?.general_information?.company_logo?.url}
              displayName={card?.company?.general_information?.fantasy_name}
              caption={card[card.owner ? 'owner' : 'equipment']?.branch?.display_name}
            />
          ),
          owner_or_equipment: card.owner ? (
            <AllCardsOwner card={card} />
          ) : card.equipment ? (
            <AllCardsEquipment card={card} />
          ) : (
            ''
          ),
          action: (
            <div className="flex items-center gap-2">
              <RequestNewCard
                id={card.id}
                disabled={!(card.status === 'printed' || card.status === 'validated')}
              />

              <Link to={card.id}>
                <Button
                  variant="link-white"
                  operationKlassToCheckPermission="Admin::Client::Cards::Show"
                >
                  <ArrowBigRight />
                </Button>
              </Link>
            </div>
          ),
          request_new_card: (
            <RequestNewCard id={card.id} />
          ),
        }
      })
    }
  }
}
